import { BsCaretRightFill } from "react-icons/bs";
import { animated, useSpring } from "react-spring";

export const MenuCaret = ({ active }) => {
  const { caretMarginLeft } = useSpring({
    from: { caretMarginLeft: "0%" },
    // 2/3 + half of 1/3 = 83.33..%
    to: { caretMarginLeft: active ? "80%" : "0%" },
    config: {
      tension: 280,
      friction: 120,
      mass: 10,
    },
  });
  return (
    <animated.div
      {...{
        style: {
          position: "absolute",
          fontSize: "0.6rem",
          marginTop: "calc(12.5% - 0.3rem)",
          marginLeft: caretMarginLeft,
        },
      }}
    >
      <BsCaretRightFill />
    </animated.div>
  );
};
